
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag/[slug]",
      function () {
        return require("private-next-pages/tag/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tag/[slug]"])
      });
    }
  